import React from 'react';

const Publication = () => {

    return (
        <div className="publications-area">
            <div className="container">

                <h2 className="title-default-left title-bar-counter text-center">
                    Why Choose ITT Council, Delhi?
                </h2>

                <div style={{ textAlign: 'justify', marginTop: '20px' }}>

                    <p>
                        <b>1. Government Recognized & Certified Quality</b><br />
                        Registered Institution: A Government of India registered organization (CIN: U74999DL2016NPL299102) established in 2016.<br />
                        Global Standards: Awarded the ISO 9001:2015 International Quality Certificate, ensuring a rigorous and effective learning environment.
                    </p>

                    <p>
                        <b>2. Industry-Driven Curriculum</b><br />
                        Job-Ready Skills: Courses are specifically designed to bridge the gap between academic knowledge and market demand.<br />
                        Future-Focused: Regular curriculum updates to include cutting-edge fields like Artificial Intelligence (AI), modern Accounting, and Technical Education.<br />
                        Diverse Options: Offers a wide range of programs including Short-term, Long-term, Diplomas, and Degrees.
                    </p>

                    <p>
                        <b>3. Robust Support for Partners (Franchisees)</b><br />
                        Entrepreneurial Focus: Promotes local growth by helping entrepreneurs set up vocational training centers.<br />
                        Comprehensive Assistance: Provides ongoing guidance, marketing resources, and administrative support to ensure the success of authorized centers.<br />
                        Zero Tolerance Policy: Maintains a strict quality control policy for study materials and program delivery across all locations.
                    </p>

                    <p>
                        <b>4. Flexible Examination & Learning</b><br />
                        Accessibility: Conducts both Online and Offline Examinations to provide flexibility for students across different regions.<br />
                        Global Reach: While headquartered in Delhi, the Council operates through a vast network of training centers both within India and internationally.
                    </p>

                    <p>
                        <b>5. Commitment to Visionary Education</b><br />
                        Inspirational Learning: Guided by the philosophy that "Imagination is more important than knowledge," fostering an environment where students learn to innovate, not just memorize.<br />
                        Holistic Development: Focuses on entrepreneurship development alongside technical skills, preparing students for the global marketplace.
                    </p>

                </div>

            </div>
        </div>
    );
};

export { Publication };